/**
 * ProGate — checks current user's professional application status on each render.
 * Shows the one-time Verified or Rejected screen if applicable, otherwise renders children.
 */
import { useEffect, useState } from "react";
import { useAuthStore } from "../../store/authStore";
import { apiClient } from "../../services/api";
import { VerifiedWelcome, RejectedScreen } from "../../pages/professional/ProTerminals";

export default function ProGate({ children }) {
  const user = useAuthStore((s) => s.user);
  const [app, setApp] = useState(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!user || shown) return;
    apiClient
      .get("/professionals/me")
      .then((r) => {
        if (r.data?.exists) setApp(r.data.application);
      })
      .catch(() => {});
  }, [user, shown]);

  if (app && app.status === "verified" && !app.verified_welcome_shown) {
    return (
      <VerifiedWelcome
        name={app.full_name}
        onDismiss={() => setShown(true)}
      />
    );
  }
  if (app && app.status === "rejected" && !app.rejection_screen_shown) {
    return (
      <RejectedScreen
        application={app}
        onDismiss={() => setShown(true)}
      />
    );
  }
  return children;
}
